// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "./filters";
import "./styles/_global.sass";
import "@mdi/font/css/materialdesignicons.css";

import CKEditor from "@ckeditor/ckeditor5-vue";
import Storage from "vue-ls";
import Vue from "vue";
import VueNumeric from "vue-numeric";
import vuetify from "@/plugins/vuetify";
import VueYoutube from "vue-youtube";

import App from "./App";
// import moment from "moment";
import moment from "moment-timezone";
import router from "./modules/global/router";
import store from "./modules/global/stores";

import firebase from "firebase";

import getOssClient from "@/modules/global/services/oss";

// Client OSS tidak lagi dibuat saat boot: kredensialnya diambil dari backend
// dan baru tersedia setelah login. $alioss adalah penerus tipis yang membangun
// client secara lazy pada pemanggilan pertama, sehingga call site tetap
// memakai bentuk `await this.$alioss.get(...)` seperti sebelumnya.
// Tambahkan method di sini bila ada operasi ali-oss lain yang dibutuhkan.
Vue.prototype.$alioss = {
    get: function () {
        var args = arguments;
        return getOssClient().then(function (client) {
            return client.get.apply(client, args);
        });
    },

    put: function () {
        var args = arguments;
        return getOssClient().then(function (client) {
            return client.put.apply(client, args);
        });
    },

    putACL: function () {
        var args = arguments;
        return getOssClient().then(function (client) {
            return client.putACL.apply(client, args);
        });
    },
};

Vue.config.productionTip = false;

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,

    // Development
    // apiKey: 'AIzaSyDUYsan2a7sbrdEek3l9DUfLcAYZ7Dd3Tg',
    // authDomain: 'skolla-dev-ce76e.firebaseapp.com',
    // databaseURL: 'https://skolla-dev-ce76e.firebaseio.com',
    // projectId: 'skolla-dev-ce76e',
    // storageBucket: 'skolla-dev-ce76e.appspot.com',
    // messagingSenderId: '285513998615',
    // appId: '1:285513998615:web:b7f04783466c003a2c1752',
    // measurementId: 'G-W0VGQF40ER'

    // Production
    // apiKey: 'AIzaSyDQpjvNVDCD1l0V1mXdlD4I9Za2qcuhp6s',
    // authDomain: 'skolla-ops-f46b5.firebaseapp.com',
    // databaseURL: 'https://skolla-ops-f46b5.firebaseio.com',
    // projectId: 'skolla-ops-f46b5',
    // storageBucket: 'skolla-ops-f46b5.appspot.com',
    // messagingSenderId: '940900983187',
    // appId: '1:940900983187:web:3f3469036fb84a0bba4866',
    // measurementId: 'G-NG98D2VSF6'
};
firebase.initializeApp(firebaseConfig);

Vue.use(Storage);
Vue.use(VueYoutube);
Vue.use(VueNumeric);
Vue.use(CKEditor);
Vue.prototype.$moment = moment;

moment.tz.setDefault("Asia/Jakarta");
moment.locale("id");
moment.updateLocale("id", {
    week: {
        dow: 1,
    },
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    template: "<App/>",
    components: {
        App,
    },
    router,
    store,
    vuetify,
});



// WEBPACK FOOTER //
// ./src/main.js